/* S685 PRE-ORDER – Samoa 685 Supporters Jersey in-stock / pre-order logic (draft theme only). v6 */
(function () {
  'use strict';
  var PRODUCT_IDS = [9007945613502, 9007944073406];
  var SURCHARGE_VARIANT = 49565383164094;
  var TXT = {
    stockBadge: function (q) { return 'In stock – ' + q + ' available, ships ASAP'; },
    preBadge: 'Pre-order – ships in 4 weeks',
    dStock: 'In stock, ships ASAP',
    dPre: 'Pre-order, ships in 4 weeks',
    notice: 'Your in-stock items ship now and your pre-orders ship separately in about 4 weeks, so a $12 split shipment fee applies.',
    optOut: 'Happy to wait? Ship everything together in about 4 weeks at the standard rate.',
    together: '<strong>Shipping together:</strong> everything ships in one parcel in about 4 weeks at the standard rate.',
    switchBack: 'Prefer your in-stock items now? Ship separately ($12 split shipment fee).',
    surchargeFail: 'We couldn’t add the $12 split shipment fee automatically – our team will confirm shipping with you.'
  };
  var OWN = { 'X-S685': '1', 'Content-Type': 'application/json', 'Accept': 'application/json' };
  var origFetch = window.fetch.bind(window);
  var surchargeUnavailable = false;

  function isJersey(pid) { return PRODUCT_IDS.indexOf(Number(pid)) > -1; }
  function isSurcharge(item) { return Number(item.variant_id) === SURCHARGE_VARIANT || (item.properties && item.properties._s685 === 'surcharge'); }
  function isPre(item) { return !!(item.properties && String(item.properties.Dispatch || '').indexOf('Pre-order') === 0); }
  function api(url, body) {
    return origFetch(url, body ? { method: 'POST', headers: OWN, body: JSON.stringify(body) } : { headers: OWN })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) { var e = new Error(j.description || j.message || r.status); e.data = j; throw e; } return j; }); });
  }
  function getCart() { return api('/cart.js'); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  /* ---------- inventory maths ---------- */
  function vState(v, inCartStock) {
    // Pre-orders are unlimited: only in-stock units are counted; anything beyond them becomes a pre-order line.
    var q = v.qty == null ? 0 : Number(v.qty);
    return { qty: q, stockLeft: Math.max(0, q - (inCartStock || 0)), status: q > 0 ? 'stock' : 'pre' };
  }

  /* ---------- product page ---------- */
  function initProduct(root) {
    var data;
    try { data = JSON.parse(root.querySelector('[data-s685-json]').textContent); } catch (e) { return; }
    var FID = root.dataset.formId; // note: form.id is shadowed by <input name="id">
    var form = document.getElementById(FID);
    if (!form) return;
    var idInput = form.querySelector('input[name="id"]');
    var btn = form.querySelector('[name="add"]');
    var qtyInput = document.querySelector('input[name="quantity"][form="' + FID + '"]') || form.querySelector('input[name="quantity"]');
    var badge = root.querySelector('[data-s685-badge]');
    var cartCounts = {};
    var lastId = null;

    // move badge directly under the size picker if one is found
    var picker = form.closest('section, .product, .product__info-wrapper') && form.closest('section, .product, .product__info-wrapper').querySelector('variant-selects, variant-radios, .product-form__input--pills, .product__variants');
    if (picker && picker.parentNode) picker.parentNode.insertBefore(root, picker.nextSibling);

    function variant() { var id = Number(idInput.value); return data.variants.filter(function (v) { return v.id === id; })[0]; }
    function refreshCartCounts() {
      return getCart().then(function (c) {
        cartCounts = {};
        c.items.forEach(function (i) { var k = cartCounts[i.variant_id] = cartCounts[i.variant_id] || { s: 0, p: 0 }; if (isPre(i)) k.p += i.quantity; else k.s += i.quantity; });
      }).catch(function () {});
    }
    function stateFor(v) { var c = cartCounts[v.id] || { s: 0, p: 0 }; return vState(v, c.s); }
    function render() {
      var v = variant(); if (!v) return;
      var st = stateFor(v);
      var html;
      if (st.status === 'stock') html = '<span class="s685-badge__pill s685-badge__pill--stock">' + esc(TXT.stockBadge(st.qty)) + '</span>';
      else html = '<span class="s685-badge__pill s685-badge__pill--pre">' + TXT.preBadge + '</span>';
      badge.innerHTML = html;
      idInput.disabled = false;
      if (btn) {
        btn.disabled = false;
        var label = btn.querySelector('span') || btn;
        label.textContent = st.status === 'stock' ? 'Add to cart' : 'Pre-order';
      }
      // No quantity cap: restore the theme's own max (variant quantity rule) if it had one, otherwise none.
      if (qtyInput) {
        if (qtyInput.dataset.s685OrigMax === undefined) qtyInput.dataset.s685OrigMax = qtyInput.getAttribute('max') || '';
        if (qtyInput.dataset.s685OrigMax) qtyInput.setAttribute('max', qtyInput.dataset.s685OrigMax); else { qtyInput.removeAttribute('max'); delete qtyInput.dataset.max; }
      }
    }
    // Theme disables sold-out size radios; for these jerseys sold-out sizes are pre-orderable, so re-enable them.
    function enableSizes() {
      document.querySelectorAll('input[type="radio"][form="' + FID + '"]').forEach(function (i) {
        if (i.disabled || i.classList.contains('disabled')) { i.disabled = false; i.removeAttribute('disabled'); i.classList.remove('disabled'); }
      });
    }
    var et; new MutationObserver(function () { clearTimeout(et); et = setTimeout(function () { enableSizes(); tick(); }, 40); })
      .observe(form.closest('section') || document.body, { childList: true, subtree: true });
    enableSizes();
    // Group sizes: "Youth sizes" block then "Adult sizes" block (values read from the actual radio options).
    function groupSizes() {
      var radios = [].slice.call(document.querySelectorAll('input[type="radio"][form="' + FID + '"]'));
      if (!radios.length) return;
      var fs = radios[0].closest('fieldset') || radios[0].parentNode;
      if (fs.querySelector('.s685-sizes')) return;
      var youth = radios.filter(function (i) { return /^youth\b/i.test(i.value); });
      var adult = radios.filter(function (i) { return !/^youth\b/i.test(i.value); });
      if (!youth.length || !adult.length) return;
      function block(label, list, mod) {
        var d = document.createElement('div'); d.className = 's685-sizes s685-sizes--' + mod;
        d.innerHTML = '<p class="s685-sizes__label">' + label + '</p><div class="s685-sizes__grid"></div>';
        var g = d.lastChild;
        list.forEach(function (i) { var l = fs.querySelector('label[for="' + i.id + '"]'); g.appendChild(i); if (l) g.appendChild(l); });
        return d;
      }
      fs.appendChild(block('Youth sizes', youth, 'youth'));
      fs.appendChild(block('Adult sizes', adult, 'adult'));
    }
    groupSizes();
    function tick() { groupSizes(); enableSizes(); if (idInput.value !== lastId) { lastId = idInput.value; setTimeout(render, 60); } }
    new MutationObserver(tick).observe(idInput, { attributes: true, attributeFilter: ['value', 'disabled'] });
    form.addEventListener('change', tick); document.addEventListener('change', function () { setTimeout(tick, 30); });
    setInterval(tick, 400);
    if (btn) new MutationObserver(function () { var v = variant(); if (v && btn.disabled) render(); }).observe(btn, { attributes: true, attributeFilter: ['disabled'] });
    refreshCartCounts().then(render); render();

    function fresh() {
      return origFetch('/products/' + root.dataset.handle + '?section_id=s685-inventory', { headers: OWN })
        .then(function (r) { return r.text(); })
        .then(function (t) { var m = t.match(/<script type="application\/json" data-s685-fresh>([\s\S]*?)<\/script>/); if (m) data = JSON.parse(m[1]); })
        .catch(function (e) { console.warn('[S685] fresh inventory check failed, using page-load data', e); });
    }

    document.addEventListener('submit', function (e) {
      if (e.target !== form) return;
      e.preventDefault(); e.stopImmediatePropagation();
      var want = Math.max(1, parseInt(qtyInput ? qtyInput.value : 1, 10) || 1);
      if (btn) btn.setAttribute('aria-busy', 'true');
      Promise.all([fresh(), refreshCartCounts()]).then(function () {
        var v = variant(); var st = stateFor(v);
        var nStock = Math.min(want, st.stockLeft), nPre = want - nStock;
        var items = [];
        if (nStock > 0) items.push({ id: v.id, quantity: nStock, properties: { Dispatch: TXT.dStock } });
        if (nPre > 0) items.push({ id: v.id, quantity: nPre, properties: { Dispatch: TXT.dPre } });
        return api('/cart/add.js', { items: items }).then(function () { return { v: v, nStock: nStock, nPre: nPre }; });
      }).then(function (res) {
        return refreshCartCounts().then(function () { return syncCart(); }).then(function (cart) { render(); showModal(res, cart); });
      }).catch(function (err) {
        console.warn('[S685] add to cart failed', err);
        var box = form.querySelector('.product-form__error-message-wrapper');
        var msg = (err && err.message) || 'Could not add to cart';
        if (box) { box.hidden = false; box.querySelector('.product-form__error-message').textContent = msg; }
        else alert(msg);
      }).then(function () { if (btn) btn.removeAttribute('aria-busy'); });
    }, true);

    function showModal(res, cart) {
      var stock = [], pre = [];
      data.variants.forEach(function (v) {
        var st = stateFor(v); var sel = v.id === res.v.id ? ' class="is-selected"' : '';
        if (st.qty > 0) stock.push('<li' + sel + '><span>' + esc(v.title) + '</span><span>' + st.qty + ' available</span></li>');
        else pre.push('<li' + sel + '><span>' + esc(v.title) + '</span><span>' + 'Ships in 4 weeks' + '</span></li>');
      });
      var j = cart.items.filter(function (i) { return isJersey(i.product_id) && !isSurcharge(i); });
      var mixed = j.some(isPre) && j.some(function (i) { return !isPre(i); });
      var added = [];
      if (res.nStock) added.push(res.nStock + ' × ' + esc(res.v.title) + ' in stock');
      if (res.nPre) added.push(res.nPre + ' × ' + esc(res.v.title) + ' on pre-order');
      var m = document.createElement('div');
      m.className = 's685-modal'; m.setAttribute('role', 'dialog'); m.setAttribute('aria-modal', 'true'); m.setAttribute('aria-labelledby', 's685-modal-title');
      m.innerHTML = '<div class="s685-modal__panel">' +
        '<button type="button" class="s685-modal__x" aria-label="Close" data-close>&times;</button>' +
        '<h3 id="s685-modal-title" class="s685-modal__title">Added to cart</h3>' +
        '<p class="s685-modal__added">' + esc(data.title) + ': ' + added.join(' + ') + '</p>' +
        '<div class="s685-modal__cols">' +
        '<div><h4 class="s685-modal__h s685-modal__h--stock">In stock – ready to dispatch</h4><ul>' + (stock.join('') || '<li><span>None right now</span></li>') + '</ul></div>' +
        '<div><h4 class="s685-modal__h s685-modal__h--pre">Pre-order – ships in 4 weeks</h4><ul>' + (pre.join('') || '<li><span>None</span></li>') + '</ul></div>' +
        '</div>' +
        (mixed ? '<p class="s685-modal__split">In-stock items ship now and pre-orders ship separately when they arrive, so there’s a $12 split shipment fee.</p>' : '') +
        '<div class="s685-modal__actions"><a class="button button--filled uppercase" href="/cart" data-s685-continue>Continue to cart</a>' +
        '<button type="button" class="button button--outlined uppercase" data-close>Change size</button></div></div>';
      document.body.appendChild(m);
      function close() { m.remove(); document.removeEventListener('keydown', onKey); }
      function onKey(e) { if (e.key === 'Escape') close(); }
      m.addEventListener('click', function (e) {
        if (e.target.closest && e.target.closest('[data-s685-continue]')) {
          var d = document.querySelector('cart-drawer');
          if (d && typeof d.open === 'function') { e.preventDefault(); close(); refreshDrawer(false).then(function () { d.open(); }); }
          return; // no drawer: fall back to the /cart link
        }
        if (e.target === m || e.target.hasAttribute('data-close')) close();
      });
      document.addEventListener('keydown', onKey);
      m.querySelector('a').focus();
      refreshDrawer(false);
    }
  }

  /* ---------- cart sync (cart page + drawer) ---------- */
  var syncing = null, again = false;
  function syncCart() {
    if (syncing) { again = true; return syncing; }
    var changed = false;
    syncing = getCart().then(function step(cart) {
      var jersey = cart.items.filter(function (i) { return isJersey(i.product_id) && !isSurcharge(i); });
      var sur = cart.items.filter(isSurcharge);
      var mixed = jersey.some(isPre) && jersey.some(function (i) { return !isPre(i); });
      var mode = (cart.attributes && cart.attributes.s685_ship) === 'Together' ? 'Together' : 'Split';
      var want = mixed ? mode : null;
      // 1. Ship property on jersey lines
      var bad = jersey.filter(function (i) { return (i.properties.Ship || null) !== want; })[0];
      if (bad) {
        var props = Object.assign({}, bad.properties); if (want) props.Ship = want; else delete props.Ship;
        changed = true;
        return api('/cart/change.js', { id: bad.key, quantity: bad.quantity, properties: props }).then(step);
      }
      // 2. surcharge line
      var needSur = mixed && mode === 'Split';
      if (!needSur && sur.length) { changed = true; return api('/cart/change.js', { id: sur[0].key, quantity: 0 }).then(step); }
      if (needSur && sur.length > 1) { changed = true; return api('/cart/change.js', { id: sur[1].key, quantity: 0 }).then(step); }
      if (needSur && sur.length === 1 && sur[0].quantity !== 1) { changed = true; return api('/cart/change.js', { id: sur[0].key, quantity: 1 }).then(step); }
      if (needSur && !sur.length && !surchargeUnavailable) {
        return api('/cart/add.js', { items: [{ id: SURCHARGE_VARIANT, quantity: 1, properties: { _s685: 'surcharge' } }] })
          .then(function () { changed = true; return getCart().then(step); })
          .catch(function (e) {
            surchargeUnavailable = true;
            console.warn('[S685] Split shipment surcharge (variant ' + SURCHARGE_VARIANT + ') could not be added – the product probably is not published to the Online Store.', e);
            return cart;
          });
      }
      return cart;
    }).then(function (cart) {
      renderNotices(cart);
      syncing = null;
      if (changed) refreshTheme(); else sessionStorage.removeItem('s685-reload');
      if (again) { again = false; return syncCart(); }
      return cart;
    }, function (e) { syncing = null; console.warn('[S685] cart sync failed', e); });
    return syncing;
  }

  function renderNotices(cart) {
    var jersey = cart.items.filter(function (i) { return isJersey(i.product_id) && !isSurcharge(i); });
    var mixed = jersey.some(isPre) && jersey.some(function (i) { return !isPre(i); });
    var mode = (cart.attributes && cart.attributes.s685_ship) === 'Together' ? 'Together' : 'Split';
    var hasSur = cart.items.some(isSurcharge);
    var html = '';
    if (mixed) {
      html = '<div class="s685-cart__box">' + (mode === 'Together'
        ? '<p class="s685-cart__msg">' + TXT.together + '</p><button type="button" class="s685-cart__link" data-s685-ship="Split">' + TXT.switchBack + '</button>'
        : '<p class="s685-cart__msg">' + TXT.notice + '</p>' + (!hasSur && surchargeUnavailable ? '<p class="s685-cart__warn">' + TXT.surchargeFail + '</p>' : '') +
          '<button type="button" class="s685-cart__link" data-s685-ship="Together">' + TXT.optOut + '</button>') + '</div>';
    }
    document.querySelectorAll('[data-s685-cart-notice]').forEach(function (el) { el.innerHTML = html; });
  }

  // Re-render the theme's cart drawer + header count via the Section Rendering API (same sections the theme uses).
  function refreshDrawer(open) {
    var d = document.querySelector('cart-drawer');
    var counts = function (c) { document.querySelectorAll('.cart-count-badge, .cart-drawer__title-counter').forEach(function (el) { el.textContent = c.item_count; }); };
    if (!d || typeof d.renderContents !== 'function') return getCart().then(counts).catch(function () {});
    // Fetch the theme's own cart-drawer section and swap its body in (what the theme's renderContents does, minus its brittle selector).
    return origFetch('/?sections=cart-drawer', { headers: OWN })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        var doc = new DOMParser().parseFromString(res['cart-drawer'] || '', 'text/html');
        var nb = doc.getElementById('CartDrawer-Body'), ob = document.getElementById('CartDrawer-Body');
        if (nb && ob) ob.innerHTML = nb.innerHTML; else console.warn('[S685] drawer section missing body', (res['cart-drawer'] || '').slice(0, 120));
        if (open) d.open();
        return getCart();
      })
      .then(function (c) { counts(c); renderNotices(c); if (typeof updateCartCounters === 'function') try { updateCartCounters(); } catch (e) {} })
      .catch(function (e) { console.warn('[S685] drawer refresh failed', e); });
  }
  window.S685_refreshDrawer = refreshDrawer;

  function refreshTheme() {
    // Re-render the theme's cart UI so new/removed lines show. Cart page: reload once; drawer: ask theme sections to refresh.
    if (/^\/cart\/?$/.test(location.pathname)) {
      if (sessionStorage.getItem('s685-reload') !== '1') { sessionStorage.setItem('s685-reload', '1'); location.reload(); }
      return;
    }
    refreshDrawer(false);
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-s685-ship]');
    if (!b) return;
    e.preventDefault();
    var mode = b.getAttribute('data-s685-ship');
    if (mode === 'Split') surchargeUnavailable = false;
    b.disabled = true;
    api('/cart/update.js', { attributes: { s685_ship: mode } }).then(syncCart).then(function () { sessionStorage.removeItem('s685-reload'); refreshTheme(); });
  });

  // Resync whenever anything else changes the cart (theme quantity buttons, remove, drawer, etc.)
  var t;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var own = init && init.headers && init.headers['X-S685'];
    var p = origFetch(input, init);
    if (!own && /\/cart\/(add|change|update|clear)/.test(url)) {
      p.then(function () { clearTimeout(t); t = setTimeout(syncCart, 350); });
    }
    return p;
  };

  function boot() {
    document.querySelectorAll('[data-s685-product]').forEach(initProduct);
    if (document.querySelector('[data-s685-cart-notice]')) syncCart();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  window.S685 = { sync: syncCart };
})();
